module.exports = __webpack_public_path__ + "img/icon-moneybag.a93c62ed.svg";